import React from "react";
import "./css/ChoosePlans.css";
import { getPlanFeatures } from "../utils/planDescriptions";
import { useTranslation } from "../../../i18n/LanguageContext";

const ChoosePlans = ({ onCancel, onPlanSelected, onGoToApp }) => {
  const { t } = useTranslation();

  const plans = [
    {
      title: t("servicePlans.plan.individual.name"),
      price: "$9.99/mo",
      features: getPlanFeatures("individual", t),
    },
    {
      title: t("servicePlans.plan.family.name"),
      price: "$19.99/mo",
      features: getPlanFeatures("family", t),
    },
    {
      title: t("servicePlans.plan.extended_family.name"),
      price: "$29.99/mo",
      features: getPlanFeatures("extended_family", t),
    },
  ];

  const handlePlanClick = (plan) => {
    onPlanSelected(plan); // Notify ContentPanel.js
  };

  return (
    <div className="choose-plans">
      <button
        className="choose-plans-close-btn"
        onClick={onCancel}
        title={t("common.close")}
        aria-label={t("common.close")}
      >
        ✕
      </button>
      <h1>{t("choosePlans.title")}</h1>
      <p className="choose-plans-description">
        {t("choosePlans.description")}
      </p>
      <div className="plans-container">
        {plans.map((plan, index) => (
          <div key={index} className="plan-card">
            <h2>{plan.title}</h2>
            <p className="plan-price">{plan.price}</p>
            <ul>
              {plan.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <button className="got-it-button" onClick={onGoToApp || onCancel}>
        {t("choosePlans.btn.start")}
      </button>
      <button className="choose-plans-close-bottom-btn" onClick={onCancel}>
        {t("common.close")}
      </button>
    </div>
  );
};

export default ChoosePlans;
